import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useDeleteStaff, useStaffListQuery } from "../api/queries";
import { StaffTable } from "../ui/StaffTable";
import { StaffToolbar } from "../ui/StaffToolbar";

type StaffSearch = {
  offset?: number;
  limit?: number;
  q?: string;
};

export function StaffPage() {
  const nav = useNavigate({ from: "/app/performance/staff" });
  const search: StaffSearch = useSearch({ from: "/app/performance/staff" });
  const offset = search.offset ?? 0;
  const limit = search.limit ?? 20;

  const list = useStaffListQuery({ q: search.q, limit, skip: offset });
  const canCreate = useActionPermission(["performance-payouts:create"]);
  const deleteStaff = useDeleteStaff();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Staff" },
          ]}
        />
      </Header>

      <Main>
        <StaffToolbar
          canManage={!!canCreate}
          onCreate={() => nav({ to: "/app/performance/staff/create" })}
        />

        <div className="rounded-xl border bg-card pt-2">
          <StaffTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={offset}
            limit={limit}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(nextOffset, nextLimit) =>
              nav({ search: { ...search, offset: nextOffset, limit: nextLimit } })
            }
            onEdit={(row) =>
              nav({
                to: "/app/performance/staff/$id/edit",
                params: { id: row.id },
              })
            }
            onDelete={(id) => {
              void deleteStaff.run(id);
            }}
          />
        </div>
      </Main>
    </>
  );
}
